<ng-container *ngIf="dataIn.isSingle; else multiple">
  <rk-modal-wrapper
    (submitted)="onSubmit()"
    (cancelled)="onCancel()"
    (closed)="onAbort()"
    [title]="'MEDIA.MODAL.TRASH.DELETE.TITLE_SINGLE' | translate"
    [submitText]="'MEDIA.MODAL.TRASH.DELETE.ACTION_BUTTON' | translate"
    [loading]="isLoading$ | async"
    [hideCancelOnLoading]="true"
  >
    <div
      class="head-delete-track-modal-component"
      [innerHTML]="
        'MEDIA.MODAL.TRASH.DELETE.HEADER_SINGLE'
          | translate: { name: dataIn.archivedTrack.title }
      "
    ></div>

    <div
      class="body-delete-track-modal-component"
      translate="MEDIA.MODAL.TRASH.DELETE.NOT_UNDOABLE"
    ></div>
  </rk-modal-wrapper>
</ng-container>

<ng-template #multiple>
  <rk-modal-wrapper
    (submitted)="onSubmit()"
    (cancelled)="onCancel()"
    (closed)="onAbort()"
    [title]="
      (dataIn.isAll
        ? 'MEDIA.MODAL.TRASH.DELETE.TITLE_ALL'
        : 'MEDIA.MODAL.TRASH.DELETE.TITLE_MULTIPLE'
      ) | translate
    "
    [submitText]="
      (dataIn.isAll
        ? 'MEDIA.MODAL.TRASH.DELETE.ACTION_BUTTON_ALL'
        : 'MEDIA.MODAL.TRASH.DELETE.ACTION_BUTTON'
      ) | translate
    "
    [loading]="isLoading$ | async"
    [hideCancelOnLoading]="true"
  >
    <div
      class="head-delete-track-modal-component"
      [innerHTML]="
        'MEDIA.MODAL.TRASH.DELETE.HEADER_MULTIPLE'
          | translate: { tracks: dataIn.archivedTrackIdList.length }
      "
    ></div>

    <div
      class="body-delete-track-modal-component"
      translate="MEDIA.MODAL.TRASH.DELETE.NOT_UNDOABLE"
    ></div>
  </rk-modal-wrapper>
</ng-template>
